export default __webpack_public_path__ + "static/media/farewell.ac27f3bb.jpg";